import * as types from "./followUpActionTypes";

const initialState = {
  data: null,
};

export default function FollowUpReducer(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case types.SET_FOLLOW_UP_CHECKBOXES:
      return { "count": action.count };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/follow-ups/FollowUpReducer.js